import { connect } from "react-redux";
import InvoiceValidationList from "./InvoiceList";
import { bindActionCreators } from "redux";
import {getInvoiceList, close} from "../../../../services/redux/sales/InvoiceValidation/action";

const mapStateToProps = (state) => ({
    invoiceList: state.InvoiceModule.invoiceList,
    ticketClosed: state.InvoiceModule.ticketClosed,
});

const mapDispatchToProps = (dispatch) =>
    bindActionCreators(
        {
            getInvoiceList,
            close
        },
        dispatch
    );

export default connect(mapStateToProps, mapDispatchToProps)(InvoiceValidationList);
